module.exports = __webpack_public_path__ + "img/star-review.ae5b0d0f.svg";